import { Link } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { useTranslation } from "@/hooks/useTranslation"
import { FlagOutlined } from "@/icons"
import { InformationAlert } from "@/molecules/InformationAlert"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { SlackConfigurationTab } from "./SlackConfigurationTab"

import styles from "./SlackConfigurationPage.module.scss"

import type { SlackConfiguration } from "@/api/useIntegrations.types"

export const SlackConfigurationPage = () => {
  const vendor = INTEGRATION_VENDORS.slack
  const [data] = useIntegration({ vendor })
  const configuration = data?.configuration as SlackConfiguration | undefined
  const { t } = useTranslation()
  const { ROOT, WORKFLOWS } = NAMES_ROUTES.GOVERNANCE

  return (
    <ConfigurationPageTemplate
      vendor={vendor}
      config={<SlackConfigurationTab vendor={vendor} />}
      titleKey="integrations.configuration.slack.configurationTitle"
      prefixConfig={
        !!configuration?.installations?.length && (
          <InformationAlert
            icon={<FlagOutlined />}
            message={t("integrations.slack.workflows.title")}
            description={
              <span className={styles.description}>
                {t("integrations.slack.workflows.first")}
                <Link to={`/${ROOT}/${WORKFLOWS}`}>
                  {t("general.workflow", { count: 1 })}
                </Link>
                {t("integrations.slack.workflows.second")}
              </span>
            }
          />
        )
      }
    />
  )
}
